//

import React, { useState } from 'react'

// importing material UI components
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import IconButton from '@mui/material/IconButton'
import AppleIcon from '@mui/icons-material/Apple'
import AppsIcon from '@mui/icons-material/Apps'
import { Instagram, Telegram, Twitter } from '@mui/icons-material'
import { ReactComponent as PlayStoreIcon } from '../../../assets/images/playstore.svg'
import LogoDark from '../../../assets/images/logo-dark.svg'
import Logo from '../../../assets/images/logo-light.svg'
import LogoImg from '../../../assets/images/logo.svg'
import QRCode from '../../../assets/images/qrcode.svg'
import './header.css'
import { ThemeSwitcher, useMatchBreakpoints, Flex } from '@pancakeswap/uikit'
import NetworkSwitch from 'components/Menu/NetworkSwitch'
import UserMenu from 'components/Menu/UserMenu'
import { Link } from 'react-router-dom'
import useTheme from 'hooks/useTheme'
import styled from 'styled-components'
import {
  ABOUT_US_LINK,
  AML_KYC_LINK,
  API_DOCUMENT_LINK,
  BUY_CRYPTO_LINK,
  COOKIE_POLICY_LINK,
  DERIVATIVES_LINK,
  DEX_LINK,
  DEX_SINGLE_LINK,
  FAQ_LINK,
  INSTAGRAM_LINK,
  INSTITUTIONAL_SERVICES_LINK,
  MAIN_CHAIN,
  MAIN_SITE_LINK,
  MARKETS_LINK,
  MARKET_MAKERS_LINK,
  MEDIA_PRESS_LINK,
  NCX_AMBASSADOR_LINK,
  NCX_CARD_LINK,
  NCX_TOKEN_LINK,
  NCX_WALLET_LINK,
  NEWS_INSIGHTS_LINK,
  OTC_LINK,
  PRIVACY_POLICY_LINK,
  REWARDS_PROGRAM_LINK,
  SIGNIN_LINK,
  SIGNUP_LINK,
  SPOT_TRADING_LINK,
  TELEGRAM_LINK,
  TWITTER_LINK,
  USER_AGREEMENT_LINK,
} from 'config/constants/links'
import { alpha } from '@mui/material/styles'

const MobileFooterContainer = styled.div`
  position: fixed;
  width: 100%;
  height: 64px;
  left: 0;
  top: calc(100% - 64px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px;
  z-index: 100;
  :before {
    content: '';
    background-color: ${({ theme }) => theme.colors.background};
    // backdrop-filter: blur(4px);
    border-radius: 0;
    box-shadow: 0 0 12px 6px ${({ theme }) => theme.colors.cardBorder};
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
`

const HoverButton = styled.div<{ hoverWhite?: boolean }>`
  background: black; //${({ theme, hoverWhite }) => (hoverWhite ? theme.colors.text : 'transparent')};
  border: 1.5px solid ${({ theme }) => theme.colors.cardBorder};
  display: flex;
  color: white; //${({ theme, hoverWhite }) => (hoverWhite ? theme.colors.background : theme.colors.text)};
  justify-content: center;
  align-items: center;
  height: 32px;
  padding: 0px 10px;
  font-size: 15px;
  border-radius: 8px;
  transition: 0.3s;
  cursor: pointer;
  div.btn-icon {
    position: relative;
    border-radius: 5px;
    width: 26px;
    height: 26px;
    padding: 5px;
    background: ${({ theme }) => alpha(theme.colors.text, 0.1)};
    img {
      width: 100%;
      height: 100%;
      filter: brightness(0);
    }
  }
  :hover {
    background: ${({ theme }) => theme.colors.primary};
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme, hoverWhite }) => (hoverWhite ? 'white' : theme.colors.text)};
    div.btn-icon img {
      filter: none !important;
    }
  }
  a {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    text-decoration: none;
    color: inherit;
  }
`

const StyledHeaderLink = styled.div<{ isActive?: boolean }>`
  position: relative;
  display: flex;
  color: ${({ theme, isActive }) => (isActive ? theme.colors.text : theme.colors.text)};
  font-size: 16px;
  text-align: center;
  padding: 0;
  a {
    color: inherit;
    text-decoration: none;
  }
  :after {
    content: '';
    position: absolute;
    bottom: -5px;
    width: ${({ isActive }) => (isActive ? '100%' : '0')};
    height: 1.5px;
    background-color: ${({ theme }) => theme.colors.primary};
    transition: 0.3s;
  }
  :hover {
    color: ${({ theme }) => theme.colors.text}!important;

    :after {
      width: 100%;
    }
  }
`

const StyledMobileButton = styled.div<{ isActive?: boolean }>`
  position: relative;
  display: flex;
  flex: 1;
  height: 36px;
  justify-content: center;
  align-items: center;
  padding: 5px;
  border-radius: 50px;
  color: ${({ theme, isActive }) => (isActive ? 'white' : theme.colors.text)};
  border: 1px solid ${({ theme, isActive }) => (isActive ? theme.colors.primary : theme.colors.text)};
  background-color: ${({ theme, isActive }) => (isActive ? 'black' : theme.colors.background)};
  font-size: 16px;
  a {
    color: inherit;
    text-decoration: none;
    white-space: nowrap;
  }
`
const StyledMobileLink = styled.div`
  position: relative;
  display: flex;
  color: ${({ theme }) => theme.colors.text};
  font-size: 18px;
  font-weight: 300;
  padding: 14px 0;

  width: 100%;
  justify-content: center;
  a {
    color: inherit;
    text-decoration: none;
  }
`
const HeaderLink = ({
  to,
  title,
  isActive = false,
  style,
}: {
  to: string
  title: string
  isActive?: boolean
  style?: any
}) => {
  if (!to || !title) return null
  if (to.startsWith('http'))
    return (
      <StyledHeaderLink isActive={isActive} style={style}>
        <a href={to}>{title}</a>
      </StyledHeaderLink>
    )
  return (
    <StyledHeaderLink isActive={isActive} style={style}>
      <Link to={to}>{title}</Link>
    </StyledHeaderLink>
  )
}
const MobileLink = ({ to, title }: { to: string; title: string }) => {
  if (!to || !title) return null
  if (to.startsWith('http'))
    return (
      <StyledMobileLink>
        <a href={to}>{title}</a>
      </StyledMobileLink>
    )
  return (
    <StyledMobileLink>
      <Link to={to}>{title}</Link>
    </StyledMobileLink>
  )
}
const MobileButton = ({
  to,
  title,
  isActive,
  style,
}: {
  to: string
  title: string
  isActive?: boolean
  style?: any
}) => {
  if (!to || !title) return null
  if (to.startsWith('http'))
    return (
      <StyledMobileButton isActive={isActive} style={style}>
        <a href={to}>{title}</a>
      </StyledMobileButton>
    )
  return (
    <StyledMobileButton isActive={isActive} style={style}>
      <Link to={to}>{title}</Link>
    </StyledMobileButton>
  )
}

export default function HeaderBar(): any {
  const [isNavExpanded, setIsNavExpanded] = useState(false)
  const { theme, isDark, toggleTheme } = useTheme()
  const { isMobile } = useMatchBreakpoints()

  return (
    <>
      <AppBar position="static" id="header-row" style={{ marginTop: 0 }}>
        <Toolbar
          style={{
            minHeight: 56,
            background: theme.colors.background,
            boxShadow: isMobile ? `0 0 12px 6px ${theme.colors.cardBorder}` : 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div id="main-header" className="desktop">
            <div className="logo-nav">
              <IconButton size="large" edge="start" color="inherit" aria-label="menu" className="header-logo">
                <a href={MAIN_SITE_LINK} style={{ marginRight: 5 }}>
                  <img src={isDark ? LogoDark : Logo} alt="NCX-Logo" />
                </a>
                {/* <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 30,
                  padding: '0 0 0 10px',
                  margin: '0 0 0 10px',
                  borderLeft: `1px solid ${theme.colors.text}`,
                  color: theme.colors.text,
                  fontWeight: 100,
                }}
              >
                DEX
              </div> */}
              </IconButton>
              <div className="headermore_row">
                <a className="header-more" href="/#">
                  <AppsIcon style={{ fill: theme.colors.text }} />
                </a>
                <div id="new-headermenu" className="mega_menu">
                  <div className="col1">
                    <div className="top_heading connect_link_title">
                      <h4>Products</h4>
                      <h4>Services</h4>
                      <h4>Company</h4>
                    </div>
                    <div className="menu_box">
                      <div className="col">
                        <div className="main_service_wrapper">
                          <div className="community_inner">
                            <div className="main_service">
                              <a href={BUY_CRYPTO_LINK}>Buy Crypto</a>
                              <a href={SPOT_TRADING_LINK}>Spot Trading</a>
                              <a href={DERIVATIVES_LINK}>Derivatives Trading</a>
                              <a href={MARKETS_LINK}>Markets</a>
                              <Link to="/swap">DEX</Link>
                              <a href={NCX_CARD_LINK}>NCX Card</a>
                              <a href={NCX_TOKEN_LINK}>NCX Token</a>
                            </div>
                          </div>
                          <div className="social_links">
                            <div className="social_link_inner">
                              <a href={REWARDS_PROGRAM_LINK}>Rewards Program</a>
                              <a href={NEWS_INSIGHTS_LINK}>NCX Insights</a>
                              <a href={MARKET_MAKERS_LINK}>Market Makers</a>
                              <a href={INSTITUTIONAL_SERVICES_LINK}>Institutional Services</a>
                              <a href={OTC_LINK}>OTC</a>
                              <a href={NCX_AMBASSADOR_LINK}>NCX Ambassador</a>
                            </div>
                          </div>
                          <div className="social_links">
                            <div className="social_link_inner">
                              <a href={ABOUT_US_LINK}>About Us</a>
                              <a href={MEDIA_PRESS_LINK}>Media & Press</a>
                              <a href={USER_AGREEMENT_LINK}>User Agreement</a>
                              <a href={AML_KYC_LINK}>AML & KYC Policy</a>
                              <a href={PRIVACY_POLICY_LINK}>Privacy Policy</a>
                              <a href={API_DOCUMENT_LINK}>API Documentation</a>
                              <a href={COOKIE_POLICY_LINK}>Cookie Policy</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col2">
                    <div className="right_inner">
                      <h4>Support</h4>
                      <div className="connect_links">
                        <div className="box">
                          <div className="boxx-links">
                            <a href={FAQ_LINK}>FAQ</a>
                            <a href="/#">Open Support Ticket</a>
                            <a href="/#">Support via Telegram</a>
                          </div>
                          <h4>Social Media</h4>
                          <div className="social-icons">
                            <div className="icons">
                              <a href={TELEGRAM_LINK}>
                                <Telegram style={{ fill: 'white' }} />
                              </a>
                            </div>
                            <div className="icons">
                              <a href={TWITTER_LINK} target="_blank" rel="noreferrer">
                                <Twitter style={{ fill: 'white' }} />
                              </a>
                            </div>
                            <div className="icons">
                              <a href={INSTAGRAM_LINK} target="_blank" rel="noreferrer">
                                <Instagram style={{ fill: 'white' }} />
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <ul className="navlink">
                  <HeaderLink to={BUY_CRYPTO_LINK} title="Buy Crypto" />
                  <HeaderLink to={SPOT_TRADING_LINK} title="Spot Trading" />
                  <HeaderLink to={DERIVATIVES_LINK} title="Derivatives" />
                  <HeaderLink to={MARKETS_LINK} title="Markets" />
                  <HeaderLink to={DEX_LINK} title="DEX" />
                  <HeaderLink to={NCX_CARD_LINK} title="NCX Card" />
                  <HeaderLink to={NCX_WALLET_LINK} title="NCX Wallet" />
                  <HeaderLink to={NCX_TOKEN_LINK} title="NCX Token" />
                  <HeaderLink to={REWARDS_PROGRAM_LINK} title="Rewards" />
                </ul>
              </div>
            </div>
            <div className="login-buttons">
              <ThemeSwitcher isDark={isDark} toggleTheme={toggleTheme} />
              <HoverButton style={{ width: 75, borderColor: theme.colors.primary }} hoverWhite>
                <a href={SIGNIN_LINK}>Sign In</a>
              </HoverButton>
              <HoverButton style={{ width: 60, borderColor: theme.colors.primary }} hoverWhite>
                <a href={DEX_LINK}>DeFi</a>
              </HoverButton>
              <div className="downloadQRCode">
                <HoverButton id="downloadlink" style={{ borderWidth: 1, width: 60 }} hoverWhite>
                  <AppleIcon style={{ color: 'white', width: 20, height: 20 }} />
                  <PlayStoreIcon style={{ color: 'white', width: 14, height: 14, marginLeft: 5 }} />
                </HoverButton>
                <div id="headerDownloadApp">
                  <div className="download-box">
                    <div className="qr-box">
                      <div className="img-box">
                        <img src={QRCode} alt="NCX Mobile App" />
                      </div>
                    </div>
                    <div className="pc-box">
                      <div className="text">Scan the QR code to download NCX mobile APP</div>
                    </div>
                  </div>
                </div>
              </div>
              <UserMenu />
            </div>
          </div>

          <div
            id="header-newmobile"
            className={isNavExpanded ? 'header-expanded active' : 'header-expanded'}
            style={{ background: theme.colors.background }}
          >
            <nav className="navigation">
              <div className="navigation-one">
                <div className="mobile-logo">
                  <IconButton
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    className="header-logo"
                    sx={{ mr: 2 }}
                  >
                    <a href={MAIN_SITE_LINK}>
                      <img src={isDark ? LogoDark : Logo} alt="NCX-Logo" />
                    </a>
                  </IconButton>
                </div>
                <div className="mobile-toogle">
                  {/* <UserMenu /> */}
                  <button type="button" className="hamburger" onClick={() => setIsNavExpanded(!isNavExpanded)}>
                    <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M0.875 0.5H18.125V1.49902H0.875V0.5ZM1 7.50098L18.125 7.5V8.49902L1 8.5V7.50098ZM0.875 14.5H18.125V15.499H0.875V14.5Z"
                        fill={theme.colors.text}
                      />
                    </svg>
                  </button>
                  <div className={`navigation-menu ${isNavExpanded ? 'expanded' : ''} ${isDark ? 'dark' : ''}`}>
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
                      <MobileButton to={DEX_SINGLE_LINK} title="Swap" isActive={false} />
                      <MobileButton to={DEX_LINK} title="Cross-Chain Swap" isActive />
                      {/* <MobileButton to={NCX_CARD_LINK} title="Card" /> */}
                    </div>
                    <div style={{ padding: '20px 0', width: '100%' }}>
                      {/* <MobileLink to={DEX_LINK} title="NCX DEX" /> */}
                      <MobileLink to={BUY_CRYPTO_LINK} title="Buy Crypto" />
                      <MobileLink to={SPOT_TRADING_LINK} title="Spot Trading" />
                      <MobileLink to={DERIVATIVES_LINK} title="Derivatives" />
                      <MobileLink to={MARKETS_LINK} title="Markets" />
                      <MobileLink to={DEX_LINK} title="DEX" />
                      <MobileLink to={NCX_CARD_LINK} title="NCX Card" />
                      {/* <MobileLink to={NCX_WALLET_LINK} title="NCX DeFi Wallet" /> */}
                      <MobileLink to={NCX_TOKEN_LINK} title="NCX Token" />
                      <MobileLink to={REWARDS_PROGRAM_LINK} title="Rewards" />
                      {/* <MobileLink to={INSTITUTIONAL_SERVICES_LINK} title="Institutional" /> */}
                      {/* <MobileLink to={NCX_AMBASSADOR_LINK} title="NCX Ambassador" /> */}
                      <MobileLink to={NEWS_INSIGHTS_LINK} title="News & Insights" />
                    </div>
                    <div style={{ display: 'flex', gap: 10, justifyContent: 'center', paddingBottom: 20 }}>
                      <MobileButton
                        to={SIGNIN_LINK}
                        title="Sign In / Sign Up"
                        style={{ width: '40%', height: 44, borderRadius: 5 }}
                        isActive
                      />
                      {/* <MobileButton to={SIGNUP_LINK} title="Sign Up" style={{ width: '40%', height: 44 }} /> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="mobile-launch">
                <div className="dropdown">
                  <button type="button" className="dropbtn">
                    Launch DEX
                  </button>
                  <div className="dropdown-content">
                    <a href="/#" target="_blank" rel="noreferrer">
                      Launch DEX
                    </a>
                    <a href={SIGNIN_LINK} target="_blank" rel="noreferrer">
                      Sign In
                    </a>
                    {/* <a href="/#" target="_blank" rel="noreferrer">Sign Up</a> */}
                  </div>
                </div>
              </div>
            </nav>
          </div>
          <div id="main-subheader" className="desktop">
            <div className="logo-nav">
              <HoverButton style={{ borderWidth: 1, width: 126, height: 36, backgroundColor: 'transparent' }}>
                <a href={BUY_CRYPTO_LINK} style={{ textDecoration: 'none', color: theme.colors.text }}>
                  <div className="btn-icon">
                    <img src={LogoImg} alt="NCX-Logo" style={{ filter: isDark ? 'grayscale(1)' : 'brightness(0)' }} />
                  </div>
                  Buy NCXT
                </a>
              </HoverButton>
            </div>
            <div>
              <ul className="navlink">
                <HeaderLink to={DEX_SINGLE_LINK} title="Swap" isActive style={{ fontSize: 18 }} />
                <HeaderLink
                  to={DEX_LINK}
                  title="Cross-Chain Swap"
                  style={{ fontSize: 18, color: alpha(theme.colors.text, 0.5) }}
                />
                <HeaderLink
                  to={NCX_CARD_LINK}
                  title="Card"
                  style={{ fontSize: 18, color: alpha(theme.colors.text, 0.5) }}
                />
              </ul>
            </div>
          </div>
        </Toolbar>
      </AppBar>

      {isMobile && (
        <MobileFooterContainer>
          <NetworkSwitch chain={MAIN_CHAIN} />
          <Flex alignItems="center" style={{ gap: 10 }}>
            <ThemeSwitcher isDark={isDark} toggleTheme={toggleTheme} />
            <UserMenu />
          </Flex>
        </MobileFooterContainer>
      )}
    </>
  )
}
